<script setup lang="ts">
const DURATION_MS = 250;

// Anime la hauteur du bloc qui entre ou sort. Le délai de repli couvre un `transitionend` qui ne vient pas
// (mouvement réduit, onglet en arrière-plan).
const settle = (el: Element, done: () => void) => {
  let finished = false;
  const finish = () => {
    if (finished) return;
    finished = true;
    el.removeEventListener('transitionend', finish);
    done();
  };
  el.addEventListener('transitionend', finish);
  setTimeout(finish, DURATION_MS + 50);
};

const grow = (el: Element, done: () => void) => {
  const box = el as HTMLElement;
  void box.offsetHeight;
  box.style.height = `${box.scrollHeight}px`;
  settle(el, done);
};

const shrink = (el: Element, done: () => void) => {
  const box = el as HTMLElement;
  box.style.height = `${box.scrollHeight}px`;
  void box.offsetHeight;
  box.style.height = '0px';
  settle(el, done);
};
</script>

<template>
  <Transition
    name="fold"
    @before-enter="(el: Element) => ((el as HTMLElement).style.height = '0px')"
    @enter="grow"
    @after-enter="(el: Element) => ((el as HTMLElement).style.height = '')"
    @leave="shrink"
  >
    <slot />
  </Transition>
</template>

<style>
/* Le bloc replié annule l'écart du `gap` de la carte, pour que la carte ne saute pas au début et à la fin. */
.fold-enter-active,
.fold-leave-active {
  overflow: hidden;
  transition:
    height 250ms ease,
    opacity 250ms ease,
    margin-top 250ms ease;
}

.fold-enter-from,
.fold-leave-to {
  opacity: 0;
  margin-top: calc(-1 * var(--fold-gap, 10px));
}

@media (prefers-reduced-motion: reduce) {
  .fold-enter-active,
  .fold-leave-active {
    transition: none;
  }
}
</style>
